import { Component, EventEmitter, Injector, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { OverlayPanel } from 'primeng/overlaypanel';
import { ToastService } from 'src/app/core/services/toast.service';
import { SessionBaseComponent } from '../session.base.component';

@Component({
  selector: 'laas-custom-rows-per-page',
  templateUrl: './custom-rows-per-page.component.html',
  styleUrl: './custom-rows-per-page.component.scss'
})
export class CustomRowsPerPageComponent extends SessionBaseComponent
implements OnInit, OnChanges {

  customRowsPerPage: number | null = null;
  @Input() disabled: boolean = true;
  @Input() rowsPerPage: number | undefined = 0;
  @Input() rowsPerPageOptions: number[] = [5, 10, 20, 50, 100];
  @Output() syncRowsPerPage = new EventEmitter<number[]>();
  @Output() selectRowsPerPage = new EventEmitter<number>();
  @ViewChild('op') op!: OverlayPanel;

  constructor(
    private injector: Injector
  ) {
    super(injector);
  }

  ngOnChanges(changes: SimpleChanges): void {
    console.log('changes', changes);
  }

  onRemoveItem(event: MouseEvent, item: number) {
    /* 阻止事件冒泡 */
    event.stopPropagation();
    const filteredOptions = this.rowsPerPageOptions.filter((i) => i !== item);
    if (!filteredOptions.length) {
      this.toastService.error('至少要保留一個選項');
      return;
    }
    this.rowsPerPageOptions = this.rowsPerPageOptions.filter((i) => i !== item);
    this.syncRowsPerPage.emit(this.rowsPerPageOptions);
    this.reAlign();
  }

  onSelectRowsPerPage(item: number) {
    this.rowsPerPage = item;
    this.selectRowsPerPage.emit(item);
    this.op.hide();
  }

  showOverlayPanel($event: MouseEvent) {
    this.op.toggle($event);
  }

  onAddRowsPerPage(): void {
    if (!this.customRowsPerPage) {
      return;
    }
    if (!Number.isInteger(this.customRowsPerPage) || this.customRowsPerPage <= 0) {
      this.toastService.error('請輸入大於 0 的正整數');
      return;
    }
    if (this.customRowsPerPage > 1000) {
      this.toastService.error('請輸入小於 1000 的數字');
      return;
    }
    this.rowsPerPageOptions = [...this.rowsPerPageOptions, this.customRowsPerPage]
    .sort((a, b) => a - b);
    this.syncRowsPerPage.emit(this.rowsPerPageOptions);
    this.customRowsPerPage = null; // 清空輸入框
    this.reAlign();
  }

  reAlign() {
    return setTimeout(() => {
      this.op.align();
    }, 0);
  }
}
